import { IAvailability, IItemType, ISalesTax, ISalesType, ITag, IUnit } from './index.js'

export const IResource = {
  name: 'Albania',
  currency: 'ALL',
  phone_code: 355,
  code: 'AL',
  language: 'sq',
  language_name: 'Albanian',
  currency_sign: 'L',
  currency_sign_position: 'before',
  currency_decimal_number: 2,
}

export const IEntityResource = {
  availability_summary: [IAvailability],
  tax: [ISalesTax],
  unit: [IUnit],
  item_type: [IItemType],
  sale_type: [ISalesType],
  tag: [ITag],
}
